import { render } from "./EditAssignationPage.vue?vue&type=template&id=1ced8468&ts=true"
import script from "./EditAssignationPage.vue?vue&type=script&lang=ts"
export * from "./EditAssignationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__